<template>
  <div class="w-full bg-white">
    <!-- 顶部切换条：仅工作台主人可见 -->
    <div
      v-if="options.length"
      class="flex items-center gap-3 px-4 h-11 border-b border-neutral-100 bg-white"
    >
      <i class="fa fa-window-maximize text-neutral-400"></i>
      <el-select
        v-model="currentId"
        size="small"
        style="width: 200px"
        placeholder="切换工作台"
        @change="switchTo"
      >
        <el-option
          v-for="o in options"
          :key="o.id"
          :label="o.name"
          :value="o.id"
        />
      </el-select>
      <span class="text-xs text-neutral-400 hidden sm:inline">
        数据仅你可见，换设备登录也一致
      </span>
      <div class="ml-auto flex items-center gap-2">
        <button
          class="px-3 py-1.5 rounded-lg border border-neutral-200 text-xs text-neutral-600 hover:border-primary hover:text-primary transition-colors"
          @click="reload"
        >
          <i class="fa fa-refresh mr-1"></i>刷新
        </button>
        <router-link
          to="/workbench"
          class="px-3 py-1.5 rounded-lg border border-neutral-200 text-xs text-neutral-600 hover:border-primary hover:text-primary transition-colors"
        >
          管理
        </router-link>
      </div>
    </div>

    <div v-if="error" class="py-24 text-center text-sm text-neutral-500">
      <i class="fa fa-exclamation-circle mr-1"></i>{{ error }}
    </div>
    <iframe
      v-else-if="src"
      :key="src"
      :src="src"
      class="w-full border-0"
      :style="{ height: iframeHeight }"
      allow="fullscreen; clipboard-write"
    ></iframe>
    <div v-else class="py-24 text-center text-sm text-neutral-400">
      <i class="fa fa-spinner fa-spin mr-2"></i>正在加载工作台…
    </div>
  </div>
</template>

<script>
/**
 * 工作台运行页：站内 iframe 打开用户自己的 HTML 工作台。
 * 后端会把 window.WB 数据桥注入页面，业务数据按账号隔离。
 */
export default {
  name: "WorkbenchRunPage",
  data() {
    return {
      src: "",
      error: "",
      options: [],
      currentId: "",
    };
  },
  computed: {
    iframeHeight() {
      return this.options.length ? "calc(100vh - 105px)" : "calc(100vh - 61px)";
    },
  },
  watch: {
    "$route.params.id"(val) {
      this.currentId = val;
      this.build();
    },
  },
  mounted() {
    this.currentId = this.$route.params.id || "";
    this.build();
    this.loadList();
  },
  methods: {
    build() {
      const id = this.$route.params.id;
      if (!id) {
        this.error = "缺少工作台参数";
        return;
      }
      const share = (this.$route.query && this.$route.query.s) || "";
      const token = localStorage.getItem("token") || "";
      if (!token && !share) {
        this.error = "请先登录后再打开工作台";
        return;
      }
      this.error = "";
      const root = process.env.VUE_APP_API_ROOT || "/api/v1";
      const params = ["id=" + encodeURIComponent(id)];
      if (token) params.push("tk=" + encodeURIComponent(token));
      if (share) params.push("s=" + encodeURIComponent(share));
      this.src = `${root}/user/workbench/bridge/page?${params.join("&")}`;
    },
    /** 拉取自己的全部工作台，用于顶部切换；分享来访者不显示 */
    loadList() {
      if (!localStorage.getItem("token")) return;
      if (this.$route.query && this.$route.query.s) return;
      this.$axios({ url: "user/workbench/mine" })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.options = res.data.list || [];
          }
        })
        .catch(() => {});
    },
    switchTo(id) {
      if (!id || id === this.$route.params.id) return;
      this.$router.replace("/workbench/run/" + id);
    },
    reload() {
      const base = this.src.split("&_t=")[0];
      this.src = base + "&_t=" + Date.now();
    },
  },
};
</script>
